import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Can be either `}<inlineCode parentName="p">{`payment-failed`}</inlineCode>{` which is an error from the PSP side, or `}<inlineCode parentName="p">{`cancelled-by-customer`}</inlineCode>{` which means the failure initiated on the customer side. I.e. cancelling a 3DS flow. `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      